export interface CaseAddress {
  id: string;
  slug?: string | null;
}

export const caseHref = (caseItem: CaseAddress): string => `/cases/${encodeURIComponent(caseItem.slug || caseItem.id)}`;
